import { soneium as viemSoneium } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const soneium = {
  displayName: 'Soneium',
  runtime: 'evm',
  viemChain: viemSoneium,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'soneium' },
    qnStreams: {
      networkKey: 'soneium-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
